import Page from 'routes/AskMeQuestions/List'

const Home = props => <Page {...props} />

export default Home
